import { useNavigate } from "react-router-dom";
import { Zap, Users, Loader2 } from "lucide-react";
import { useTerminal } from "@/lib/terminal";
import { usd, age } from "@/lib/format";

const Change = ({ bps }) => {
  if (bps == null) return null;
  const up = bps >= 0;
  return <span className={up ? "text-[#00E676]" : "text-[#FF5252]"}>{up ? "+" : ""}{(bps / 100).toFixed(1)}%</span>;
};

export const TokenRow = ({ p, fresh }) => {
  const nav = useNavigate();
  const { buy, quickAmount, busy } = useTerminal();
  const t = p.token;
  const progress = Math.min(100, (p.progressBps || 0) / 100);
  const loading = busy[`buy-${t.address}`];
  return (
    <div
      data-testid={`token-row-${t.address}`}
      onClick={() => nav(`/token/${t.address}`)}
      className={`group flex gap-3 p-2.5 border-b border-[#222634]/60 cursor-pointer hover:bg-[#161920] transition-colors ${fresh ? "row-enter" : ""}`}
    >
      <div className="relative shrink-0">
        {t.imageUrl ? (
          <img src={t.imageUrl} alt="" className="w-12 h-12 rounded object-cover bg-[#161920]" onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />
        ) : (
          <div className="w-12 h-12 rounded bg-[#161920] flex items-center justify-center font-mono text-sm text-slate-500">{t.symbol?.slice(0, 2)}</div>
        )}
        <span className="absolute -bottom-1 -right-1 px-1 rounded bg-[#08090C] border border-[#222634] text-[9px] font-mono text-slate-400">{age(p.createdTime)}</span>
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline gap-1.5">
          <span className="font-semibold text-slate-100 truncate">{t.symbol}</span>
          <span className="text-xs text-slate-500 truncate">{t.name}</span>
          {p.tokenKind === "tax" && t.tax && <span className="ml-auto text-[9px] font-mono px-1 rounded bg-[#FFD700]/10 text-[#FFD700]">TAX {t.tax.buyBps / 100}/{t.tax.sellBps / 100}</span>}
        </div>
        <div className="mt-1 flex items-center gap-3 text-[11px] font-mono text-slate-400">
          <span>MC <span className="text-slate-200">{usd(p.marketCapUsd)}</span></span>
          <span>V <span className="text-slate-200">{usd(p.volume24hUsd)}</span></span>
          <span className="flex items-center gap-0.5"><Users className="w-3 h-3" />{p.holderCount}</span>
          <Change bps={p.change1hBps} />
        </div>
        <div className="mt-1.5 h-1 rounded bg-[#161920] overflow-hidden">
          <div className="h-full bg-gradient-to-r from-[#00E676] to-[#00F0FF]" style={{ width: `${progress}%` }} />
        </div>
      </div>
      <button
        data-testid={`quick-buy-btn-${t.address}`}
        disabled={loading || !Number(quickAmount)}
        onClick={(e) => { e.stopPropagation(); buy(t.address, quickAmount, t.symbol); }}
        className="self-center shrink-0 flex items-center gap-1 px-2.5 py-1.5 rounded border border-[#00E676]/40 bg-[#00E676]/10 text-[#00E676] text-xs font-mono font-semibold hover:bg-[#00E676] hover:text-[#08090C] transition-colors disabled:opacity-50"
      >
        {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Zap className="w-3.5 h-3.5" />}
        {quickAmount}
      </button>
    </div>
  );
};
